/*8b     d888  .d88888b.  888888b.  8888888 888      8888888888 
8888b   d8888 d88P" "Y88b 888  "88b   888   888      888        
88888b.d88888 888     888 888  .88P   888   888      888        
888Y88888P888 888     888 8888888K.   888   888      8888888    
888 Y888P 888 888     888 888  "Y88b  888   888      888        
888  Y8P  888 888     888 888    888  888   888      888        
888   "   888 Y88b. .d88P 888   d88P  888   888      888        
888       888  "Y88888P"  8888888P" 8888888 88888888 88888888*/

// Get references to the button and the menu
// var body = document.body;
var button = document.getElementById('RolexHeaderMobileButton');
var header = document.getElementById('RolexHeader');

// Add click event listener to the button
button.addEventListener('click', function() {
  header.classList.toggle('rlx__header--active');
  // body.classList.toggle('rlx--mobile-active');
});

var rlxJQ = $.noConflict();

rlxJQ(document).ready(function() {

  /* Popup Video (magnific popup)
  ============================================ */
  rlxJQ('.js-rlx__popup-video').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,

    fixedContentPos: false
  });

  /* Slider (slick slider)
  ============================================ */
  rlxJQ('.js-rolex-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '',  
    nextArrow: rlxJQ('.js-rolex-slider-next'),
    dots: true,
    dotsClass: 'slick-dots rlx__slider-dashes'
  });

  /* Popup pricing modal (magnific popup)
  ============================================ */
  rlxJQ('.js-rolex-modal').magnificPopup({
    type: 'inline',
    preloader: false
  });

  /* Rolex watch gallery
  ============================================ */
  rlxJQ('.js-watch-gallery-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: rlxJQ('.js-rolex-watch-gallery-custom-prev'),
    nextArrow: rlxJQ('.js-rolex-watch-gallery-custom-next'),
    appendArrows: rlxJQ('.rlx__watch-gallery-slider'),
    dots: true,
    dotsClass: 'slick-dots rlx__keep-exploring-carousel-dashes'
  });

  rlxJQ('.js-rolex-watch-cover-mobile-gallery').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    dotsClass: 'slick-dots rlx__keep-exploring-carousel-dashes'
  });

  rlxJQ('.js-rolex-watch-gallery').on('click', function(){
    var slideIndex = rlxJQ(this).attr('data-slide')*1;
    rlxJQ('.js-watch-gallery-slider').slick('slickGoTo',slideIndex);
    rlxJQ('body').addClass('rlx__watch-gallery-active');
  });

  rlxJQ('.js-rolex-watch-gallery-close').on('click', function(){
    rlxJQ('body').removeClass('rlx__watch-gallery-active');
  });

  var watchGalleryContainer = rlxJQ('.rlx__watch-gallery-slider-container');
  var height = watchGalleryContainer.height();
  watchGalleryContainer.width(height);

  /* Collection grid load more (magnific popup)
  ============================================ */
  rlxJQ('.js-rolex-load-more').click(function(){
    var sectionId = rlxJQ(this).attr('data-section-id');
    rlxJQ('#shopify-section-' + sectionId).find('.rlx__collection-grid-block--extra').show();
    rlxJQ('#shopify-section-' + sectionId).find('.rlx__collection-grid-button-wrapper').hide();
  });

  rlxJQ('.js-rolex-hours').click(function(){
    rlxJQ(this).find('.js-rolex-hours-dropdown').toggle();
  });

  /* Contact Module
  ============================================ */
  rlxJQ('.js-contact-module-next').click(function(){
    rlxJQ('.js-contact-module-page1').hide();
    rlxJQ('.js-contact-module-page2').show();
  });

  rlxJQ('.js-rlx-contact-email').on('change', function(){
    if(rlxJQ(this).val() != ""){
      rlxJQ('.js-rlx-contact-phone').removeClass('js-required');
    } else {
      rlxJQ('.js-rlx-contact-phone').addClass('js-required');
    }
  });

  rlxJQ('.js-rlx-contact-phone').on('change', function(){
    if(rlxJQ(this).val() != ""){
      rlxJQ('.js-rlx-contact-email').removeClass('js-required');
    } else {
      rlxJQ('.js-rlx-contact-email').addClass('js-required');
    }
  });

  rlxJQ('.js-contact-module-submit').click(function(){
    var isValidated = true;
    rlxJQ('.js-required').each(function(){
      if(rlxJQ(this).val() == ""){
        rlxJQ(this).parents('.js-input-wrapper').addClass('js-input-wrapper--error');
        isValidated = false;
      } else {
        rlxJQ(this).parents('.js-input-wrapper').removeClass('js-input-wrapper--error');
      }
    });
    if(!rlxJQ('.js-terms-and-conditions').is(':checked')){
      rlxJQ('.js-terms-and-conditions').parents('.js-input-wrapper').addClass('js-input-wrapper--error');
      isValidated = false;
    } else {
      rlxJQ('.js-terms-and-conditions').parents('.js-input-wrapper').removeClass('js-input-wrapper--error');
    }
    if(isValidated){
      if (typeof _satellite !== 'undefined') {
        _satellite.track("contactForm");
      }
      rlxJQ(this).parents('form').submit();
    }
  });

  rlxJQ('.js-required').on('change keyup', function(){
    if(rlxJQ(this).parents('.js-input-wrapper').hasClass('js-input-wrapper--error') && rlxJQ(this).val().length > 0){
      rlxJQ(this).parents('.js-input-wrapper').removeClass('js-input-wrapper--error');
    };
  });

  rlxJQ('.js-get-directions').on('click', function(){
    if (typeof _satellite !== 'undefined') {
      _satellite.track("getDirections");
    }
  });

  rlxJQ('.js-find-store').on('click', function(){
    if (typeof _satellite !== 'undefined') {
      _satellite.track("findStore");
    }
  });

  rlxJQ('.js-phone').on('click', function(){
    if (typeof _satellite !== 'undefined') {
      _satellite.track("contactCall");
    }
  });

  rlxJQ('.js-whatsapp').on('click', function(){
    if (typeof _satellite !== 'undefined') {
      _satellite.track("whatsappContact");
    }
  });

  rlxJQ('.js-download').on('click', function(){
    if (typeof _satellite !== 'undefined') {
      _satellite.track("download");
    }
  });

  /* Accordion
  ============================================ */
  rlxJQ('.js-rolex-accordion').on('click', function(){
    rlxJQ(this).parents('.rlx__accordion').find('.rlx__accordion-section--active').removeClass('rlx__accordion-section--active');
    rlxJQ(this).parents('.rlx__accordion-section').toggleClass('rlx__accordion-section--active');
  });

  /* Keep Exploring Custom (slick slider)
  ============================================ */
  rlxJQ('.js-rolex-keep-exploring-custom').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '',
    nextArrow: rlxJQ('.js-rolex-keep-exploring-custom-next'),
    dots: true,
    dotsClass: 'slick-dots rlx__keep-exploring-carousel-dashes',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });

  /* Keep Exploring (slick slider)
  ============================================ */
  rlxJQ('.js-rolex-keep-exploring').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '',
    nextArrow: rlxJQ('.js-rolex-keep-exploring-next'),
    dots: true,
    dotsClass: 'slick-dots rlx__keep-exploring-carousel-dashes',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });

  /* ===================================
    Price Geolocation
    Show the price if the users IP is
    from Canada. By default, the price
    is hidden.
  =================================== */
  rlxJQ.get('//www.cloudflare.com/cdn-cgi/trace').done(function(data) {
    var country_code = data.replace(/(\r\n|\n|\r)/gm,"").split('loc=');
    country_code = country_code[1].split('tls=');
    country_code = country_code[0];
    if( country_code == 'CA' ){
      rlxJQ('.js-rolex-price').addClass('js-rolex-price--show');
    } else {
      rlxJQ('.js-rolex-price').remove();
    }
  });

});


/* ===================================
  AJAX Form Submit
=================================== */
var form = document.getElementById("RolexContactForm");
var redirect = document.getElementById("RolexFormRedirect");
var formResponse = document.getElementById("RolexFormResponse");
var errorMessage = "Oops! There was a problem submitting your form";

if (form) {
  async function handleSubmit(event) {
    event.preventDefault();
    var data = new FormData(event.target);
    fetch(event.target.action, {
      method: form.method,
      body: data,
      headers: {
          'Accept': 'application/json'
      }
    }).then(response => {
      if (response.ok) {
        if (typeof _satellite !== 'undefined') {
          _satellite.track("contactForm");
        }
        form.reset();
        window.location.href = redirect.value;
      } else {
        response.json().then(data => {
          if (Object.hasOwn(data, 'errors')) {
            formResponse.innerHTML = errorMessage;
            formResponse.classList.add('error');
            fadeIn(formResponse, 300);
            setTimeout(function() {
              fadeOut(formResponse, 300);
            }, 5000);
          } else {
            formResponse.innerHTML = errorMessage;
            formResponse.classList.add('error');
            fadeIn(formResponse, 300);
            setTimeout(function() {
              fadeOut(formResponse, 300);
            }, 5000);
          }
        })
      }
    }).catch(error => {
      formResponse.innerHTML = errorMessage;
      formResponse.classList.add('error');

      fadeIn(formResponse, 300);
      setTimeout(function() {
        fadeOut(formResponse, 300);
      }, 5000);
    });
  }
  form.addEventListener("submit", handleSubmit);
}